var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useCallback, useMemo, useEffect } from "react";
import { Pane, Button, MenuSection, } from "@folio/stripes/components";
import { useIntl, FormattedMessage } from "react-intl";
import { useOkapiKy } from "@folio/stripes/core";
import { useMutation, useQuery, useQueryClient } from "react-query";
import styles from "./RequestableTitleList.module.css";
import NavComponent from "../NavComponent";
import TableComponent from "../TableComponent";
import { RecekPaneSet } from "../RecekPaneSet";
import { createStripesSource } from "../../utils/createStripesSource";
import { formatLibraryName } from "../../utils/formatUtils";
import { useTitleWithIsbnFilters } from "../../hooks/useTitleWithIsbnFilters";
import { TitleWithIsbnFilters } from "../TitleWithIsbnFilters";
import { usePublishersData } from "../../hooks/usePublishersData";
import { useTitlesIsbnTable } from "../../hooks/useTitlesIsbnTable";
import { useTitleSort } from "../../hooks/useTitleSort";
import { useListErrorMessage } from "../../hooks/useListErrorMessage";
import { columnSortKeys } from "../../utils/titleSort";
import { TitleDetailPane } from "./TitleDetailPane";
import { LibraryNoteDialog } from "./LibraryNoteDialog";
import { SendEnforcementDialog } from "../enforcement/SendEnforcementDialog";
import { fetchRequestableTitles, } from "../../api/titleService";
import { useCanRequestCopies } from "../../hooks/useCanRequestCopies";
import { useRequestableTitleActions } from "../../hooks/useRequestableTitleActions";
import { fetchDepositRecordsByTitle, requestCopy, previewRequestCopy, receiveDeposit, reportDamaged, } from "../../api/enforcementService";
import { toTitleInfo, } from "../../types/TitleSearch";
import { DEFAULT_PAGE_SIZE } from "../../utils/pageSize";
import { usePageSize } from "../../hooks/usePageSize";
import { isCountCapped } from "../../utils/exactCount";
import { formatCountSubtitle } from "../../utils/paneCount";
import { useExactTotalCount } from "../../hooks/useExactTotalCount";
import { invalidateDepositRecordViews } from "../../utils/depositRecordQueries";
import { VARIANT_TITLES_COLUMN_WIDTH } from "../../hooks/useVariantTitlesColumn";
var COLUMN_WIDTHS = {
    mainTitle: "20%",
    partNumber: "5%",
    partName: "7%",
    variantTitles: VARIANT_TITLES_COLUMN_WIDTH,
    firstContributor: "12%",
    publisher: "12%",
    publicationYear: "7%",
    editionStatement: "9%",
    // Weights of the visible columns only; "Vazba/formát" cannot wrap, so it needs room for its text and sort icon.
    bindingText: "14%",
    depositStatuses: "18%",
    isbn: "13%",
};
var buildParams = function (filters) {
    var name = filters.name.trim();
    var isbn = filters.isbn.trim();
    var publisherId = filters.publisherId.trim();
    var requestedOnly = filters.statuses.includes("requested");
    return __assign(__assign(__assign(__assign({}, (name && { title: name })), (isbn && { isbn: isbn })), (publisherId && { publisherId: publisherId })), (requestedOnly && { requestedOnly: true }));
};
export var RequestableTitleList = function () {
    var _a, _b, _c;
    var _d = useCanRequestCopies(), canRequestCopies = _d.canRequestCopies, isCanRequestLoading = _d.isLoading;
    var formatMessage = useIntl().formatMessage;
    var kyInstance = useOkapiKy();
    var queryClient = useQueryClient();
    var _e = useState(true), filterPaneIsVisible = _e[0], setFilterPaneIsVisible = _e[1];
    var _f = useRequestableTitleActions(), selectedTitle = _f.selectedTitle, handleSelectTitle = _f.handleSelectTitle, handleCloseSelectedTitle = _f.handleCloseSelectedTitle;
    var _g = useState(false), showSendDialog = _g[0], setShowSendDialog = _g[1];
    var _h = useState(false), libraryNoteDialogOpen = _h[0], setLibraryNoteDialogOpen = _h[1];
    var _j = useState(new Set()), expandedEnforcementRecordIds = _j[0], setExpandedEnforcementRecordIds = _j[1];
    var _k = useState(0), pageOffset = _k[0], setPageOffset = _k[1];
    var _l = usePageSize(), pageSize = _l.pageSize, setPageSize = _l.setPageSize;
    var _m = useState(0), totalRecords = _m[0], setTotalRecords = _m[1];
    var _o = useTitleWithIsbnFilters(), filters = _o.filters, appliedFilters = _o.appliedFilters, publisherQuery = _o.publisherQuery, handleFilterChange = _o.handleFilterChange, handleStatusChange = _o.handleStatusChange, handlePublisherInput = _o.handlePublisherInput, handleApplyFilters = _o.handleApplyFilters, handleClearFilters = _o.handleClearFilters, isAnyFilterActive = _o.isAnyFilterActive, hasUnappliedChanges = _o.hasUnappliedChanges;
    var _p = usePublishersData(publisherQuery, filters.publisherId, "WITH_ISBN"), publishers = _p.publishers, isPublishersLoading = _p.isPublishersLoading, selectedPublisher = _p.selectedPublisher;
    var baseColumns = useTitlesIsbnTable(true).columns;
    var sortKeys = useMemo(function () { return columnSortKeys(baseColumns); }, [baseColumns]);
    var _q = useTitleSort("requestable", sortKeys), sort = _q.sort, handleSort = _q.handleSort;
    useEffect(function () {
        setPageOffset(0);
    }, [appliedFilters, sort]);
    var _r = useQuery(["requestableTitles", appliedFilters, sort, pageOffset, pageSize], function () {
        var searchParams = buildParams(appliedFilters);
        return fetchRequestableTitles(kyInstance, __assign(__assign({}, searchParams), { sortBy: sort.sortBy, sortDir: sort.sortDir, offset: pageOffset, limit: pageSize }));
    }, {
        keepPreviousData: true,
        onSuccess: function (responseData) {
            var _a;
            setTotalRecords((_a = responseData.totalRecords) !== null && _a !== void 0 ? _a : 0);
        },
    }), data = _r.data, isLoading = _r.isLoading, isFetching = _r.isFetching, isError = _r.isError, error = _r.error, refetchTitles = _r.refetch;
    var titlesData = (_a = data === null || data === void 0 ? void 0 : data.items) !== null && _a !== void 0 ? _a : [];
    var totalRecordsExact = data === null || data === void 0 ? void 0 : data.totalRecordsExact;
    var exactTotalRecords = useExactTotalCount({
        queryKey: ["requestableTitles", appliedFilters],
        fetchTotalRecords: function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetchRequestableTitles(kyInstance, __assign(__assign({}, buildParams(appliedFilters)), { offset: 0, limit: DEFAULT_PAGE_SIZE, exactCount: true }))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.totalRecords];
                }
            });
        }); },
        totalRecordsExact: totalRecordsExact,
    });
    var effectiveTotalRecords = exactTotalRecords !== null && exactTotalRecords !== void 0 ? exactTotalRecords : totalRecords;
    var countIsCapped = isCountCapped(totalRecordsExact, exactTotalRecords);
    var errorMessage = useListErrorMessage(error);
    var columns = useMemo(function () {
        return baseColumns.map(function (col) {
            if (col.key === "mainTitle") {
                return __assign(__assign({}, col), { clickable: true, onClick: function (item) { return handleSelectTitle(item); } });
            }
            return col;
        });
    }, [baseColumns]);
    var toggleFilterPane = useCallback(function () { return setFilterPaneIsVisible(function (prev) { return !prev; }); }, []);
    var handlePageSizeChange = useCallback(function (size) {
        setPageSize(size);
        setPageOffset(0);
    }, [setPageSize]);
    var source = createStripesSource({
        ky: null,
        data: titlesData,
        totalRecords: effectiveTotalRecords,
        isLoading: isLoading,
        isError: isError,
        errorMessage: errorMessage,
        isLoaded: true,
        fetchMore: function () { return setPageOffset(pageOffset + pageSize); },
    });
    var _s = useQuery(["deposit-records-by-title", selectedTitle === null || selectedTitle === void 0 ? void 0 : selectedTitle.id], function () { return fetchDepositRecordsByTitle(kyInstance, selectedTitle.id); }, { enabled: !!(selectedTitle === null || selectedTitle === void 0 ? void 0 : selectedTitle.id) }), _t = _s.data, depositRecords = _t === void 0 ? [] : _t, isDepositRecordsLoading = _s.isLoading;
    var toggleEnforcementRecord = useCallback(function (recordId) {
        setExpandedEnforcementRecordIds(function (prev) {
            var next = new Set(prev);
            if (next.has(recordId)) {
                next.delete(recordId);
            }
            else {
                next.add(recordId);
            }
            return next;
        });
    }, []);
    var requestCopyPreview = useQuery(["request-copy-preview", selectedTitle === null || selectedTitle === void 0 ? void 0 : selectedTitle.id], function () { return previewRequestCopy(kyInstance, selectedTitle.id); }, { enabled: showSendDialog && !!(selectedTitle === null || selectedTitle === void 0 ? void 0 : selectedTitle.id), staleTime: 30000 }).data;
    var invalidateData = useCallback(function () {
        invalidateDepositRecordViews(queryClient);
        queryClient.invalidateQueries(["requestableTitles"]);
        refetchTitles();
    }, [queryClient, refetchTitles]);
    var requestCopyMutation = useMutation(function (_a) {
        var titleId = _a.titleId, formData = _a.formData;
        return requestCopy(kyInstance, titleId, {
            communicationType: formData.communicationType,
            subject: formData.subject,
            body: formData.body,
            recipientAddress: formData.recipientAddress,
            notes: formData.notes,
        });
    }, {
        onSuccess: function () {
            setShowSendDialog(false);
            invalidateData();
        },
    });
    var receiveMutation = useMutation(function (depositRecordId) { return receiveDeposit(kyInstance, depositRecordId); }, { onSuccess: function () { return invalidateData(); } });
    var damagedMutation = useMutation(function (depositRecordId) { return reportDamaged(kyInstance, depositRecordId); }, { onSuccess: function () { return invalidateData(); } });
    var handleCloseDetail = useCallback(function () {
        handleCloseSelectedTitle();
        setExpandedEnforcementRecordIds(new Set());
    }, [handleCloseSelectedTitle]);
    var detailSubtitle = useMemo(function () {
        var _a, _b;
        return [
            selectedTitle === null || selectedTitle === void 0 ? void 0 : selectedTitle.publisher,
            formatLibraryName((_a = depositRecords[0]) === null || _a === void 0 ? void 0 : _a.libraryName, (_b = depositRecords[0]) === null || _b === void 0 ? void 0 : _b.libraryStatus, formatMessage),
        ]
            .filter(Boolean)
            .join(" \u2014 ");
    }, [selectedTitle, depositRecords, formatMessage]);
    var titleInfo = useMemo(function () { return (selectedTitle ? toTitleInfo(selectedTitle) : undefined); }, [selectedTitle]);
    if (isCanRequestLoading) {
        return null;
    }
    if (!canRequestCopies) {
        return null;
    }
    return (React.createElement(RecekPaneSet, null,
        filterPaneIsVisible && (React.createElement(Pane, { id: "menuPane", defaultWidth: "25%", paneTitle: formatMessage({
                id: "ui-br-legaldeposits.pane.title.navigation",
            }) },
            React.createElement("div", { className: styles.flexColumn },
                React.createElement(NavComponent, null),
                React.createElement(Button, { buttonStyle: "none", id: "clickable-reset-all", disabled: !isAnyFilterActive(), marginBottom0: true, onClick: handleClearFilters },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.button.resetAll" })),
                React.createElement(TitleWithIsbnFilters, { filters: filters, suggestScope: "REQUESTABLE", publishers: publishers, isPublishersLoading: isPublishersLoading, selectedPublisher: selectedPublisher, showIsbnFilter: true, showExtraCopiesFilter: false, volumeStatuses: ["requested"], onFilterChange: handleFilterChange, onStatusChange: handleStatusChange, onPublisherInput: handlePublisherInput, onApplyFilters: handleApplyFilters, hasUnappliedChanges: hasUnappliedChanges() })))),
        React.createElement(Pane, { id: "contentPane", defaultWidth: "fill", paneTitle: formatMessage({
                id: "ui-br-legaldeposits.navigation.requestable-titles",
            }), paneSub: formatCountSubtitle(formatMessage, effectiveTotalRecords, countIsCapped) },
            React.createElement(TableComponent, { data: titlesData, columns: columns, columnWidths: COLUMN_WIDTHS, columnPrefsKey: "titles.requestable", pageSize: pageSize, onPageSizeChange: handlePageSizeChange, totalCount: effectiveTotalRecords, onNeedMoreData: function (offset) { return setPageOffset(offset); }, searchTerm: "", filterPaneIsVisible: filterPaneIsVisible, toggleFilterPane: toggleFilterPane, source: source, isFetching: isFetching, onRowClick: handleSelectTitle, sortBy: sort.sortBy, sortDir: sort.sortDir, onSort: handleSort, resetPaginationKey: "".concat(JSON.stringify(appliedFilters), "|").concat(sort.sortBy, "|").concat(sort.sortDir) })),
        selectedTitle && (React.createElement(Pane, { id: "detailPane", defaultWidth: "35%", paneTitle: formatMessage({
                id: "ui-br-legaldeposits.detail.heading",
            }), onClose: handleCloseDetail, dismissible: true, actionMenu: function () { return (React.createElement(MenuSection, { label: formatMessage({
                    id: "ui-br-legaldeposits.action.menu.label",
                }), id: "actions-menu" },
                React.createElement(Button, { buttonStyle: "dropdownItem", fullWidth: true, onClick: function () { return setShowSendDialog(true); } },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.detail.actions.requestCopy" })),
                React.createElement(Button, { buttonStyle: "dropdownItem", fullWidth: true, onClick: function () { return setLibraryNoteDialogOpen(true); } },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.title.libraryNote.actionMenu" })))); } },
            React.createElement(TitleDetailPane, { title: (_b = selectedTitle.mainTitle) !== null && _b !== void 0 ? _b : "", subtitle: detailSubtitle, depositRecords: depositRecords, isLoading: isDepositRecordsLoading, expandedRecordIds: expandedEnforcementRecordIds, onToggleRecord: toggleEnforcementRecord, onReceive: function (id) { return receiveMutation.mutate(id); }, onReportDamaged: function (id) { return damagedMutation.mutate(id); }, onStatusChanged: invalidateData, titleId: selectedTitle.id, titleInfo: titleInfo }))),
        selectedTitle && (React.createElement(LibraryNoteDialog, { open: libraryNoteDialogOpen, titleId: selectedTitle.id, titleName: (_c = selectedTitle.mainTitle) !== null && _c !== void 0 ? _c : "", onClose: function () { return setLibraryNoteDialogOpen(false); } })),
        React.createElement(SendEnforcementDialog, { open: showSendDialog, onClose: function () { return setShowSendDialog(false); }, onSubmit: function (formData) {
                return requestCopyMutation.mutate({ titleId: selectedTitle.id, formData: formData });
            }, preview: requestCopyPreview !== null && requestCopyPreview !== void 0 ? requestCopyPreview : null, isLoading: requestCopyMutation.isLoading, dialogTitleId: "ui-br-legaldeposits.enforcement.send.requestCopy.title", submitEmailLabelId: "ui-br-legaldeposits.enforcement.send.requestCopy.submit", submitNoteLabelId: "ui-br-legaldeposits.enforcement.send.requestCopy.record" })));
};
